class DropdownLinks {

  constructor() {
    this.initializeDropdownLinks();
  }

  initializeDropdownLinks() {
    const quicklinkDropdownLinks = document.querySelectorAll('.quick-links.design-dropdown select');

    quicklinkDropdownLinks.forEach((item) => {
      item.addEventListener('change', (e) => {
        var newWindow = false;
        if (item.classList.contains('new-window')) {
          newWindow = true;
        }
        var selectedOption = item[item.selectedIndex];
        if (selectedOption.attributes['data-newwindow'] != null && selectedOption.attributes['data-newwindow'].value=='true') {
          newWindow = true;
        }
        if (newWindow) {
          window.open(selectedOption.value);
        } else {
          document.location.href = selectedOption.value;
        }
        
      });
    });
  }

}

document.addEventListener('DOMContentLoaded', () => {
  new DropdownLinks();
})
